import { ChangeDetectionStrategy, Component, Inject, LOCALE_ID } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ConfigService } from '@rxap/config';
import { Title } from '@angular/platform-browser';
import { StatusIndicatorComponent } from 'eurogard-status-check';
import { LanguageRedirectService } from 'angular-services/language-redirect.service';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { EUROGARD_DATE_FORMATS } from 'angular-forms/date-format';
import { UserAgentRedirectService } from 'angular-services/user-agent-redirect.service';

@Component({
  selector: 'eurogard-root',
  templateUrl: './app.component.html',
  styleUrls: [ './app.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ RouterOutlet, StatusIndicatorComponent ],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: EUROGARD_DATE_FORMATS },
  ],
})
export class AppComponent {

  constructor(
    @Inject(LOCALE_ID) localId: string,
    config: ConfigService<any>,
    titleService: Title,
    private languageRedirectService: LanguageRedirectService,
    private userAgentRedirectService: UserAgentRedirectService,
  ) {
    this.languageRedirectService.redirectLanguageIfNeeded();
    this.userAgentRedirectService.redirectToMobileIfNeeded();
    if (config.get('app.name', null)) {
      titleService.setTitle(config.getOrThrow('app.name'));
    }
  }

}
